var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 240,
    viewBox: "0 0 360 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 240,
    rx: 8,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.141 100.28L143.681 91.81C143.821 89.61 144.991 87.6 146.841 86.39C147.981 85.64 149.311 85.25 150.681 85.25H218.611L223.811 88.93V101.81H146.911L143.141 100.28Z",
    fill: "#C4E4F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140.991 115.62L140.301 105.28L145.311 105.29L145.981 115.28L140.991 115.62Z",
    fill: "#24293D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M216.709 112.63L212.179 180.17H147.769L143.289 113.45",
    stroke: "#24293D",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M218.878 117.61L213.898 117.28L214.698 105.28H219.708L218.878 117.61Z",
    fill: "#24293D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M200.009 99.6999H136.199V86.5899C136.199 82.4299 139.739 79.0499 144.119 79.0499H215.889C220.259 79.0499 223.809 82.4299 223.809 86.5899V99.6999H207.729",
    stroke: "#24293D",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.648 119.82V157.62",
    stroke: "#24293D",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M162.18 119.82V157.62",
    stroke: "#24293D",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M167.17 119.82V157.62",
    stroke: "#C4E4F6",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M183.68 119.82V157.62",
    stroke: "#C4E4F6",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M198.859 119.82V157.62",
    stroke: "#C4E4F6",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M193.77 119.82V157.62",
    stroke: "#24293D",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M165.34 72.91C165.34 65.68 171.2 59.83 178.42 59.83H181.24C188.47 59.83 194.32 65.69 194.32 72.91",
    stroke: "#24293D",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9495 115.62H86.0195L103.94 133.53L86.0195 151.45H99.9495L117.87 133.53L99.9495 115.62Z",
    fill: "#C4E4F6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M103.94 133.53L86.0195 151.45V144.39L96.8695 133.53L86.0195 122.68V115.62L103.94 133.53Z",
    fill: "#24293D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M117.869 133.53L99.9492 151.45V144.39L110.799 133.53L99.9492 122.68V115.62L117.869 133.53Z",
    fill: "#24293D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M260.049 115.62H273.979L256.059 133.53L273.979 151.45H260.049L242.129 133.53L260.049 115.62Z",
    fill: "#C4E4F6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M256.059 133.53L273.979 151.45V144.39L263.129 133.53L273.979 122.68V115.62L256.059 133.53Z",
    fill: "#24293D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M242.129 133.53L260.049 151.45V144.39L249.199 133.53L260.049 122.68V115.62L242.129 133.53Z",
    fill: "#24293D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.ee8ecf9ab3e22201322dbc93e448a38e.svg";
export { ForwardRef as ReactComponent };